module.exports = {
  logoHeaderImg: "https://i.ibb.co/xG27Ydk/fud-spot-log.png",
  logoHeaderImgMob: "https://i.ibb.co/98cDDmg/fud-spot-log-b.png",
};
